import USER_ROLES from 'constants/user-roles.constant';
import { SEARCH_RESTRICTIONS } from 'pages/search/constants';

const searchModule = {
  search: {
    name: 'search',
    url: '/search/:tab',
    resolver: () =>
      import(/* webpackChunkName: "searchResults" */ './search-results'),
    restrictions: {
      user: SEARCH_RESTRICTIONS,
      operator: 'OR',
    },
    data: {
      authorizedRoles: [USER_ROLES.all],
      title: 'search.results.title',
      hideFooter: true,
    },
  },
};
export default searchModule;
